import { gql } from '@apollo/client'
import { CORE_MEASUREMENT_FIELDS } from '@src/graphql/fragments/measurement'

const ALL_SCANS = gql`
  ${CORE_MEASUREMENT_FIELDS}
  query allMeasurements($pagination: Pagination, $filter: MeasurementFilter) {
    allMeasurements(pagination: $pagination, filter: $filter) {
      measurements {
        ...CoreMeasurementFields
        displayValue
      }
    }
  }
`

export default ALL_SCANS
